import {Spell} from "@/spells/model/Spell.ts";
import {cn} from "@/lib/utils.ts";

export default function SpellFacts({spell}: {spell: Spell}) {
    const facts = [
        {label: "Zeitaufwand", value: spell.time},
        {label: "Wirkungsdauer", value: spell.duration},
        {label: "Reichweite", value: spell.range},
    ];

    return (
        <dl className="mx-4 my-3 grid grid-cols-[minmax(7.5rem,9rem)_auto] overflow-hidden rounded-md border border-border bg-surface/35 text-xs">
            {facts.map(fact =>
                <FactRow key={fact.label} label={fact.label} last={false}>
                    {fact.value}
                </FactRow>)}
            <FactRow label="Komponenten" last>
                <span>{spell.components}</span>
                {spell.materialComponents &&
                    <span className="ms-1 text-muted-foreground">({spell.materialComponents})</span>}
            </FactRow>
        </dl>
    );
}

function FactRow({label, last, children}: {
    label: string;
    last: boolean;
    children: React.ReactNode;
}) {
    return <>
        <dt className={cn(
            "border-r border-border bg-surface-overlay/30 px-2 py-1 font-semibold text-muted-foreground",
            !last && "border-b",
        )} style={{fontVariant: "small-caps"}}>
            {label}
        </dt>
        <dd className={cn("min-w-0 break-words px-2 py-1", !last && "border-b border-border")}>
            {children}
        </dd>
    </>;
}
